import Link from 'next/link';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import ImageComponent from '@components/common/ImageComponent/ImageComponent';

import { BlogHomepageCardDetailsProps } from 'src/types';
import { PlatformType } from '@invideoio/web-shared/constants/common';
import { getImageSize, SizeMap } from '@utils/getImageSize';

const PROFESSION_BG_IMAGEKIT_MAP: SizeMap = {
  [PlatformType.Desktop]: { width: 200, height: 200 },
  [PlatformType.Tablet]: { width: 200, height: 200 },
  [PlatformType.Mobile]: { width: 120, height: 120 },
  default: { width: 200, height: 200 },
};

const ProfessionCard = (props: BlogHomepageCardDetailsProps) => {
  const { id, name, description, image, slug, platform, browser } = props;

  return (
    <Link href="/blog/profession/[profession]" as={`/blog/profession/${slug}/`}>
      <a className={ivclass('iv-w-[250px] sm:iv-w-[180px] iv-block')}>
        <div className="iv-block">
          <ImageComponent
            elementype="imagekit"
            loading="lazy"
            sizeTransformation={getImageSize(
              platform,
              PROFESSION_BG_IMAGEKIT_MAP,
            )}
            src={image.url || ''}
            alt={slug}
            className={ivclass(
              'xl:iv-h-[200px] xl:iv-w-[200px]',
              'iv-h-[180px] iv-w-[180px]',
              'sm:iv-h-[120px] sm:iv-w-[120px]',
              'iv-mx-auto',
              'iv-cursor-pointer',
              'iv-rounded-full',
            )}
          />
        </div>
        <div className={ivclass('iv-text-center', 'iv-mt-30', 'sm:iv-mt-25')}>
          <div
            className={ivclass(
              'iv-font-extrabold',
              'iv-text-heading-xs iv-m-heading-xs',
              'sm:iv-text-heading-2xs sm:iv-m-heading-2xs',
              'iv-cursor-pointer',
            )}
          >
            {name}
          </div>
          <div className={ivclass('iv-h-[20px] sm:iv-h-[15px]', 'iv-w-full')} />
          <div
            className={ivclass(
              'iv-text-body-2xl iv-m-body-2xl',
              'iv-font-semibold',
              'iv-text-black-50',
              'iv-cursor-pointer',
            )}
          >
            {description}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default ProfessionCard;
